// Theme configuration (new fun theme)
export const theme = {
  colors: {
    primary: "#39ff14", // Bright lime green primary
    action: "#00ccff", // Neon cyan action color
    white: "#FFFFFF",
    orange: "#ff8000", // Neon orange
    mint: "#39ff14", // Bright lime green
    coral: "#00ccff", // Neon cyan
    paleYellow: "#ffff00", // Neon yellow
    text: {
      primary: "#ffffff", // White text
      secondary: "#b0eaff", // Light blue text
      light: "#b0eaff", // Light blue text
      white: "#FFFFFF"
    },
    background: {
      primary: "#11162b", // Dark card background
      secondary: "#0a0f1c", // Dark background
      accent: "#0a0f1c", // Darker background
      dark: "#0a0f1c" // Darkest background
    },
    gradient: {
      from: "#39ff14", // Bright lime green
      to: "#00ccff" // Neon cyan
    },
    // New theme colors
    blue: {
      50: "#F0F9FF",
      100: "#E0F2FE",
      200: "#BAE6FD",
      300: "#7DD3FC",
      400: "#38BDF8",
      500: "#0EA5E9",
      600: "#0284C7",
      700: "#0369A1",
      800: "#075985",
      900: "#0C4A6E"
    },
    // New theme colors for orange/red gradient
    orange: {
      50: "#FFF7ED",
      100: "#FFEDD5",
      200: "#FED7AA",
      300: "#FDBA74",
      400: "#FB923C",
      500: "#ff4b2b",
      600: "#EA580C",
      700: "#C2410C",
      800: "#9A3412",
      900: "#7C2D12"
    },
    red: {
      50: "#FEF2F2",
      100: "#FEE2E2",
      200: "#FECACA",
      300: "#FCA5A5",
      400: "#F87171",
      500: "#ff416c",
      600: "#DC2626",
      700: "#B91C1C",
      800: "#991B1B",
      900: "#7F1D1D"
    },
    yellow: {
      100: "#FEF3C7",
      200: "#FDE68A",
      300: "#FCD34D",
      400: "#FBBF24",
      500: "#F59E0B"
    },
    pink: {
      100: "#FCE7F3",
      200: "#FBCFE8",
      300: "#F9A8D4",
      400: "#F472B6",
      500: "#EC4899"
    },
    green: {
      100: "#DCFCE7",
      500: "#22C55E"
    },
    purple: {
      100: "#F3E8FF",
      500: "#A855F7"
    },
    gray: {
      50: "#F9FAFB",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827"
    },
    red: {
      100: "#FEE2E2",
      500: "#EF4444"
    },
    success: "#22C55E",
    warning: "#F59E0B",
    danger: "#EF4444",
    error: "#EF4444",
    info: "#38BDF8"
  },
  status: {
    success: "#16A34A",
    warning: "#F59E0B",
    error: "#DC2626",
    info: "#3498DB"
  },
  border: {
    light: "#E9ECEF",
    medium: "#DEE2E6",
    dark: "#ADB5BD"
  },
  spacing: { 0:"0px", 1:"4px", 2:"8px", 3:"12px", 4:"16px", 5:"20px", 6:"24px", 8:"32px", 10:"40px", 12:"48px", 16:"64px", 20:"80px", 24:"96px", 28:"112px", 32:"128px" },
  breakpoints: { xs:"420px", sm:"640px", md:"768px", lg:"1024px", xl:"1280px" },
  typography: {
    fontFamily: { 
      primary: "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      heading: "'Fredoka', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif"
    },
    fontSize: { 
      base:"16px", 
      lg:"18px", 
      xl:"20px", 
      "2xl":"24px", 
      "3xl":"28px", 
      "4xl":"36px", 
      "5xl":"44px", 
      "6xl":"54px",
      "7xl":"72px"
    },
    fontWeight: { 
      light: 300,
      normal: 400,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800
    },
    lineHeight: { 
      normal: 1.5, 
      tight: 1.2,
      relaxed: 1.75
    }
  },
  radii: { sm:"10px", md:"16px", lg:"22px", xl:"30px", full:"999px" },
  shadow: {
    soft:"0 8px 24px rgba(0,0,0,.08)",
    medium:"0 12px 36px rgba(0,0,0,.12)",
    strong:"0 18px 48px rgba(0,0,0,.18)"
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    none: 'none'
  },
  borderRadius: {
    none: '0',
    sm: '0.125rem',
    base: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    full: '9999px'
  },
  transitions: {
    fast: '150ms ease-in-out',
    normal: '250ms ease-in-out',
    slow: '350ms ease-in-out'
  },
  z: { 
    header: 100, 
    overlay: 1300, 
    modal: 1400, 
    toast: 1700,
    hide: -1,
    auto: 'auto',
    base: 0,
    docked: 10,
    dropdown: 1000,
    sticky: 1100,
    banner: 1200,
    popover: 1500,
    skipLink: 1600,
    tooltip: 1800,
    floating: 2000
  },
  zIndex: {
    hide: -1,
    auto: 'auto',
    base: 0,
    docked: 10,
    dropdown: 1000,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800,
    floating: 2000
  }
};
export default theme;
